import hamburger from "./others/_hamburger.js";
import searchMenu from "./others/_search-menu.js";
import toggle from "./others/_toggle.js";
import accordion from "./others/_accordion.js";
import cardsEstate from "./cards/_estate.js";
import cardsEstateModal from "./cards/_estate-modal.js";
import othersSearchList from "./others/_search-list.js";
import othersSelectSearch from "./others/_select-search.js";
import buttonsShare from "./buttons/_share.js";
import buttonsFavorite from "./buttons/_favorite.js";
import formsSelect from "./forms/_select.js";
import footerSearch from "./others/_footer-search.js";
import otherHeadAlert from "./others/_head-alert.js";
import blockLifestyle from "./others/_block-lifestyle.js";
import blockCampaign from "./others/_block-campaign.js";
import formsInputCalendar from "./forms/_input-calendar.js";
import formsContainerConfirm from "./forms/_container-confirm.js";
import loanSimulation from "./others/_loan-simulation.js";
import monthlyPaymentModal from "./cards/_monthly-payment-modal.js";
import othersCountdown from "./others/_countdown.js";
import areaBarScroll from "./others/_area-bar-scroll.js";
import estateListHeaderScroll from "./others/_estate-list-header-scroll.js";
import eventDetailFixedVisual from "./others/_event-detail-fixed-visual.js";
import othersPageTop from "./others/_page-top.js";

const components = () => {
    hamburger();
    searchMenu();
    toggle();
    accordion();
    cardsEstate();
    cardsEstateModal();
    othersSearchList();
    othersSelectSearch();
    buttonsShare();
    buttonsFavorite();
    formsSelect();
    footerSearch();
    otherHeadAlert();
    blockLifestyle();
    blockCampaign();
    formsInputCalendar();
    formsContainerConfirm();
    loanSimulation();
    monthlyPaymentModal();
    othersCountdown();
    areaBarScroll();
    estateListHeaderScroll();
    eventDetailFixedVisual();
    othersPageTop();
};

export default components;
